/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type poshmarkBotOfferToLikersListingFailuresQueryVariables = {
  offerConfigId?: string | null;
  cursor?: string | null;
  limit?: number | null;
};
export type poshmarkBotOfferToLikersListingFailuresQueryResponse = {
  readonly poshmarkBotOfferToLikersListingFailures: {
    readonly items: ReadonlyArray<{
      readonly listing: {
        readonly id: string;
        readonly url: string | null;
        readonly thumbnail: string | null;
        readonly title: string;
        readonly currentPrice: number | null;
        readonly deleted: boolean;
        readonly sold: boolean;
      } | null;
      readonly failurePublicReason: string;
      readonly listingUrl: string | null;
      readonly listingId: string;
    }>;
    readonly cursor: string | null;
  } | null;
};
export type poshmarkBotOfferToLikersListingFailuresQuery = {
  readonly response: poshmarkBotOfferToLikersListingFailuresQueryResponse;
  readonly variables: poshmarkBotOfferToLikersListingFailuresQueryVariables;
};

/*
query poshmarkBotOfferToLikersListingFailuresQuery(
  $offerConfigId: String
  $cursor: String
  $limit: Int
) {
  poshmarkBotOfferToLikersListingFailures(offerConfigId: $offerConfigId, cursor: $cursor, limit: $limit) {
    items {
      listing {
        id
        url
        thumbnail
        title
        currentPrice
        deleted
        sold
      }
      failurePublicReason
      listingUrl
      listingId
    }
    cursor
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'cursor',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'limit',
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'offerConfigId',
    },
    v3 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'cursor',
            variableName: 'cursor',
          },
          {
            kind: 'Variable',
            name: 'limit',
            variableName: 'limit',
          },
          {
            kind: 'Variable',
            name: 'offerConfigId',
            variableName: 'offerConfigId',
          },
        ],
        concreteType: 'PoshmarkBotOfferToLikersListingFailurePage',
        kind: 'LinkedField',
        name: 'poshmarkBotOfferToLikersListingFailures',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'PoshmarkBotOfferToLikersListingFailure',
            kind: 'LinkedField',
            name: 'items',
            plural: true,
            selections: [
              {
                alias: null,
                args: null,
                concreteType: 'PoshmarkBotListing',
                kind: 'LinkedField',
                name: 'listing',
                plural: false,
                selections: [
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'id',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'url',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'thumbnail',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'title',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'currentPrice',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'deleted',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'sold',
                    storageKey: null,
                  },
                ],
                storageKey: null,
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'failurePublicReason',
                storageKey: null,
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'listingUrl',
                storageKey: null,
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'listingId',
                storageKey: null,
              },
            ],
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'cursor',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/],
      kind: 'Fragment',
      metadata: null,
      name: 'poshmarkBotOfferToLikersListingFailuresQuery',
      selections: v3 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [v2 /*: any*/, v0 /*: any*/, v1 /*: any*/],
      kind: 'Operation',
      name: 'poshmarkBotOfferToLikersListingFailuresQuery',
      selections: v3 /*: any*/,
    },
    params: {
      cacheID: '87c9d3c754cd74fd03ed18130002a71f',
      id: null,
      metadata: {},
      name: 'poshmarkBotOfferToLikersListingFailuresQuery',
      operationKind: 'query',
      text: 'query poshmarkBotOfferToLikersListingFailuresQuery(\n  $offerConfigId: String\n  $cursor: String\n  $limit: Int\n) {\n  poshmarkBotOfferToLikersListingFailures(offerConfigId: $offerConfigId, cursor: $cursor, limit: $limit) {\n    items {\n      listing {\n        id\n        url\n        thumbnail\n        title\n        currentPrice\n        deleted\n        sold\n      }\n      failurePublicReason\n      listingUrl\n      listingId\n    }\n    cursor\n  }\n}\n',
    },
  };
})();
(node as any).hash = '414b188fab0b77699daca10b504e4487';
export default node;
